<template>
	<div></div>
</template>

<script>
  export default {
    components: {},
	data() {
		return {}
	},
    methods: {
    }
  }
</script>

<style scoped="">
</style>
